export default {
      id: "LeapMotion-usage",
      viewBox: "0 0 60 36",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#LeapMotion",
      toString: function () {
        return this.url;
      }
    }